module.exports = __webpack_public_path__ + "img/inserter-capacity.087f93ef.png";